import { getFbAppId } from '@mode/shared/util-js';

import template from './community-share-dialog.html';

export function modeCommunityShare($window) {
  return {
    scope: {
      reportLink: '=',
      embedLink: '=',
      webUrl: '=',
    },
    template,
    link: function (scope, elem, attrs) {
      scope.embedChoice = 'js';
      scope.jsLink =
        '<a href="' +
        scope.reportLink +
        '" class="mode-embed">Mode Analytics</a><script src="' +
        scope.embedLink +
        '"></script>';
      scope.iframeLink = '<iframe src="' + scope.reportLink + '" width="100%" height="300" frameborder="0"></iframe>';
      scope.fbAppId = getFbAppId($window.document);

      function openPopup(url, title) {
        const screenX = typeof window.screenX !== 'undefined' ? window.screenX : window.screenLeft,
          screenY = typeof window.screenY !== 'undefined' ? window.screenY : window.screenTop,
          clientW = typeof window.outerWidth !== 'undefined' ? window.outerWidth : document.documentElement.clientWidth,
          clientH =
            typeof window.outerHeight !== 'undefined' ? window.outerHeight : document.documentElement.clientHeight - 22,
          width = 555,
          height = 260,
          left = Math.floor(screenX + (clientW - width) / 2),
          top = Math.floor(screenY + (clientH - height) / 2.5);

        const popup = window.open(url, title, 'height=' + height + ',width=' + width + ',top=' + top + ',left=' + left);
      }

      scope.fbShare = function () {
        if (scope.fbAppId) {
          let redirectUri = location.protocol + '//' + document.domain;
          if (location.port) {
            redirectUri += ':' + location.port;
          }
          openPopup(
            'https://www.facebook.com/dialog/share?app_id=' +
              scope.fbAppId +
              '&href=' +
              encodeURIComponent(scope.webUrl) +
              '&display=popup' +
              '&redirect_uri=' +
              encodeURIComponent(redirectUri + '/fbredirect.html'),
            'facebook'
          );
        }
      };

      scope.twitterShare = function () {
        openPopup('https://twitter.com/share?url=' + encodeURIComponent(scope.webUrl), 'twitter');
      };
    },
  };
}
modeCommunityShare.$inject = ['$window'];
